import { CpinService } from './cpin.service';
import { Overlay } from '@angular/cdk/overlay';
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { CurrencyService } from './currency.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe } from '@angular/common';
import { HttpService } from './http.service';
import { Permissions } from 'app/model/shared/backend-api-response/permissions';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
import { AzureTokenBlobPipe } from 'app/shared/pipes/azureBlobToken.pipe';
import { environment } from 'environments/environment';

declare var $: any;

@Injectable()
export class SharedService {
  tenantData$: BehaviorSubject<any>;
  tenantData: Array<any> = [];
  data$: BehaviorSubject<Array<any>>;
  data: Array<any> = [];
  total$: BehaviorSubject<number>;
  disableAllMenu = new BehaviorSubject('default');
  previousTotal: number = 0;
  newRate: number = 1;
  rGuestBookPermissions: Permissions;
  rGuestBookMessages: RGuestMessages;
  attentionCaptured = new BehaviorSubject('default');
  offerNameCalendar: any;
  offerDescriptionCalendar: any;
  newCurrency: any;
  RoomData = new BehaviorSubject('room');
  showHeader = new BehaviorSubject('default');
  previousClass: string;
  currencyInfo: any;
  public tenantId: any;
  public propertyId: any;
  fontsnormal: { normal: string; bold: string };
  fontNormal: string;
  fontBold: string;
  oldenhanceddata: any;
  constructor(
    private overlay: Overlay,
    private datePipe: DecimalPipe,
    private http: HttpClient,
    public CpinService: CpinService,
    public currencyservices: CurrencyService,
    public _config: LegacyBookInitService,
    public GoogleAnalyticsEventsService: GoogleAnalyticsEventsService,
    public httpService: HttpService,
    public azureBlobToken: AzureTokenBlobPipe
  ) {
    this.tenantId = this._config.gettenantId();
    this.propertyId = this._config.getpropertyId();
    this.rGuestBookMessages = this._config.PropertyData.rGuestMessages;
    this.rGuestBookPermissions = this._config.PropertyData.permissions;
    if (localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'cart')) {
      if (localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'cart').length > 0) {
        let localdata = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'cart'));

        if (localdata != null) {
          this.data = localdata;
          for (let i = 0; i < this.data.length; i++) {
            this.previousTotal = this.previousTotal + this.data[i].room.quoteGrandTotal;
          }
        }
      }
    }
    this.data$ = new BehaviorSubject<Array<string>>(this.data);
    this.total$ = new BehaviorSubject<number>(this.previousTotal);
    this.tenantData$ = new BehaviorSubject<Array<string>>(this.tenantData);

    if (environment.multiLanguageSupport === 'true') {
      const defaultLanguage = this._config?.PropertyData?.langCode;
      this.getLanguage(defaultLanguage);
    } else {
      this.fontsnormal = {
        normal: 'KlokanTechNotoSans-Regular',
        bold: 'KlokanTechNotoSans-Bold',
      };
      this.getFonts();
    }

    let selectedLanguage = sessionStorage.getItem(`${this.tenantId}-${this.propertyId}-selectedLanguage`);
    if (selectedLanguage && environment.multiLanguageSupport === 'true') {
      this.getLanguage(selectedLanguage);
    }
    //    this.CpinService.updateGuestInfo(this.data);
  }
  getLanguage(language) {
    if (language === 'KO') {
      this.fontsnormal = {
        normal: 'MalgunGothic-Regular',
        bold: 'MalgunGothic-Bold',
      };
    } else {
      this.fontsnormal = {
        normal: 'ArialUnicodeMS-Regular',
        bold: 'ArialUnicodeMS-Bold',
      };
    }
    this.getFonts();
  }
  roomChange(data) {
    this.RoomData.next(data);
  }
  pushHeaderData(data) {
    this.showHeader.next(data);
  }
  open() {
    // Returns an OverlayRef which is a PortalHost
    const overlayRef = this.overlay.create();

    // Create ComponentPortal that can be attached to a PortalHost

    // Attach ComponentPortal to PortalHost
  }
  clearCart() {
    this.data = [];
    this.data$.next(this.data);
    this.previousTotal = 0;
    this.total$.next(0);
    localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'cart', null);
    localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'validEnhancedata', null);
  }
  updateTenant(tenantId, tenantProperty) {
    this.tenantData$.next({ tenantId: tenantId, propertyId: tenantProperty });
    if (tenantId != null && tenantId != 'undefined' && tenantProperty != null && tenantProperty != 'undefined') {
      let currentTenant = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'tenantDetail'));
      if (currentTenant != null && currentTenant != undefined) {
        localStorage.setItem(
          this.tenantId + '-' + this.propertyId + '-' + 'tenantDetail',
          JSON.stringify({ tenantId: tenantId, propertyId: tenantProperty })
        );
        if (tenantProperty != currentTenant.propertyId) {
          this.clearCart();
        }
      } else {
        localStorage.setItem(
          this.tenantId + '-' + this.propertyId + '-' + 'tenantDetail',
          JSON.stringify({ tenantId: tenantId, propertyId: tenantProperty })
        );
      }
    } else {
      this.clearCart();
    }
  }
  updateDataFromCart() {
    let CartData;
    let cartcheck = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'cart'));
    if (cartcheck) {
      if (cartcheck.length > 0) {
        CartData = JSON.parse(localStorage.getItem(this.tenantId + '-' + this.propertyId + '-' + 'cart'));
        this.data = CartData;
        this.data$.next(this.data);
      }
    }
  }

  updateCart(id, parent) {
    // this.GoogleAnalyticsEventsService.emitEvent(this.data[id].room.roomName, "EnhancementsRemovedFromCart", "room");
    this.previousTotal = this.previousTotal - this.data[id].room.quoteGrandTotal;
    if (this.data[id].hasEnhancement) {
      localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'validEnhancedata', 'false');
    }
    for (let i = 0; i < this.data.length; i++) {
      if (i != id) {
        if (this.data[i].hasEnhancement) {
          localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'validEnhancedata', 'true');
        }
      }
    }
    this.data.splice(id, 1);
    console.log('shared');
    console.log(this.data);
    this.data$.next(this.data);
    this.total$.next(this.previousTotal);
    this.CpinService.updateGuestInfo(this.data);
    localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'cart', JSON.stringify(this.data));
    if (this.data.length == 0) {
      localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'AnalyticsId', '');
      this._config.getAnalyticsData(this.tenantId, this.propertyId);
    }
  }
  updateGrandTotal(total) {
    this.total$.next(total);
  }

  updateRoomData(data, parent) {
    if (parent == 'wbe') {
      if (this.rGuestBookPermissions.functionalPermissions.addToCart) {
        if (this.data.length < this._config.cartLimit) this.previousTotal = data.room.quoteGrandTotal + this.previousTotal;
      } else {
        this.previousTotal = data.room.quoteGrandTotal;
      }
    } else if (parent == 'shownet') {
      this.previousTotal = 0;
      for (let i = 0; i < data.orederDetails.length; i++) {
        this.previousTotal += parseFloat(data.orederDetails[i].totalSalesAmount);
      }
    }

    //   for (let i = 0; i < data.length; i++) {
    //     if (data.guestDetails[0].isCasioPlayer)
    //     {
    // let caslist = {
    //   token: 1, casinoNumber: data.guestDetails[0].casinoNumber, sessionts: new Date().getTime(), count: 1, roomIndex: this.data.length, guestIndex: 0
    // }
    //     }
    //   }
    if (this.rGuestBookPermissions.functionalPermissions.addToCart) {
      if (this.data.length < this._config.cartLimit) this.data.push(data);
    } else this.data[0] = data;

    this.total$.next(this.previousTotal);
    this.data$.next(this.data);
    this.CpinService.updateGuestInfo(this.data);
  }
  setEnhanceData(data) {
    this.oldenhanceddata = data;
    localStorage.setItem(this.tenantId + '-' + this.propertyId + '-cartEnhance', JSON.stringify(data));
  }
  getEnhanceData() {
    // return this.oldenhanceddata;
    return localStorage.getItem(this.tenantId + '-' + this.propertyId + '-cartEnhance');
  }
  updateEnhancementData(data, totalValue, method) {
    if (method == 'Add') {
      this.previousTotal = this.previousTotal + totalValue;
    } else if (method == 'Remove') {
      this.previousTotal = this.previousTotal - totalValue;
    }
    let latestData = [];
    this.data = data;
    this.data$.next(this.data);
    this.total$.next(this.previousTotal);
    console.log(data);
    localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'cart', JSON.stringify(this.data));
    if (this._config.PropertyData.permissions.functionalPermissions.allowEnhancementSelectionForSpecificDays) {
      data.forEach((element) => {
        latestData.push(element.enhanceData);
      });
      this.setEnhanceData(latestData);
    }
  }

  updateEnhanceData(room, enhanceOfferIndex, method) {
    let val: number = 0;
    let totalVal: number = 0;
    let grandTotal: number;
    let subscriptionData;
    let tax: number;
    let rval: number = 0;
    let rtax: any = 0;
    let enhanceData = this.data;
    let enhancefee = 0;
    let enhancetax = 0;

    if (method == 'add') {
      //   this.GoogleAnalyticsEventsService.emitEvent(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]["requestDescription"], "EnhancementsAddedToCart", "Enhancements");

      if (this._config.PropertyData.permissions.functionalPermissions.allowEnhancementSelectionForSpecificDays) {
        enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['totalEnhancement'].forEach((element) => {
          for (let i = 0; i < enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['dates'].length; i++) {
            if (element == enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['dates'][i]['date']) {
              enhancefee = enhancefee + enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['dates'][i]['rate'];
              enhancetax = enhancetax + enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['dates'][i]['tax'];
            }
          }
        });
        enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal'] =
          enhancefee + enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['tipAmount'];
        enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal'] = enhancetax;
        enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringCharge'] = enhancefee;
        enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTax'] = enhancetax;
      }

      enhanceData[room].enhanceData.enhancementsCount = parseFloat(enhanceData[room].enhanceData.enhancementsCount || 0) + 1;
      enhanceData[room].enhanceData.enhancementsTotal =
        parseFloat(enhanceData[room].enhanceData.enhancementsTotal || 0) +
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']);
      enhanceData[room].enhanceData.enhancementsTotalTax =
        parseFloat(enhanceData[room].enhanceData.enhancementsTotalTax || 0) +
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);

      if (enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['resortFee'] == true) {
        enhanceData[room].room['resortFeeEnhancementTotal'] =
          enhanceData[room].room['resortFeeEnhancementTotal'] +
          enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal'];
        rtax =
          parseFloat(enhanceData[room].room['resortFeeTotalTax']) +
          parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);
        rval =
          parseFloat(enhanceData[room].room['resortFeeTotal']) +
          parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']);
      } else {
        enhanceData[room].room['recurringChargesEnhancementTotal'] =
          enhanceData[room].room['recurringChargesEnhancementTotal'] +
          enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal'];
        tax =
          parseFloat(enhanceData[room].room['recurringChargesTotalTax']) +
          parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);
        val =
          parseFloat(enhanceData[room].room['recurringChargesTotal']) +
          parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']);
      }
      grandTotal =
        parseFloat(enhanceData[room].room['quoteGrandTotal']) +
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']) +
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);
    } else {
      enhanceData[room].enhanceData.enhancementsCount = parseFloat(enhanceData[room].enhanceData.enhancementsCount || 0) - 1;
      enhanceData[room].enhanceData.enhancementsTotal =
        parseFloat(enhanceData[room].enhanceData.enhancementsTotal || 0) -
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']);
      enhanceData[room].enhanceData.enhancementsTotalTax =
        parseFloat(enhanceData[room].enhanceData.enhancementsTotalTax || 0) -
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);

      if (enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['resortFee'] == true) {
        enhanceData[room].room['resortFeeEnhancementTotal'] =
          enhanceData[room].room['resortFeeEnhancementTotal'] -
          enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal'];
        rtax =
          parseFloat(enhanceData[room].room['resortFeeTotalTax']) -
          parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);
        rval =
          parseFloat(enhanceData[room].room['resortFeeTotal']) -
          parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']);
      } else {
        enhanceData[room].room['recurringChargesEnhancementTotal'] =
          enhanceData[room].room['recurringChargesEnhancementTotal'] -
          enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal'];
        tax =
          parseFloat(enhanceData[room].room['recurringChargesTotalTax']) -
          parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);
        val =
          parseFloat(enhanceData[room].room['recurringChargesTotal']) -
          parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']);
      }
      grandTotal =
        parseFloat(enhanceData[room].room['quoteGrandTotal']) -
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']) -
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);
    }
    if (method == 'add') {
      enhanceData[room].enhanceData.enhancements[enhanceOfferIndex].selected = 'Y';
      if (!enhanceData[room].SelectedEnhancements) {
        enhanceData[room].SelectedEnhancements = [];
      }
      enhanceData[room].SelectedEnhancements.push(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]);

      if (enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['resortFee'] == true) {
        enhanceData[room].room['resortFeeTotal'] = rval;
        enhanceData[room].room['resortFeeTotalTax'] = rtax;
      } else {
        enhanceData[room].room['recurringChargesTotal'] = val;
        enhanceData[room].room['recurringChargesTotalTax'] = tax;
      }
      enhanceData[room].room['quoteGrandTotal'] = grandTotal;
      let totalAdd =
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']) +
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);
      this.updateEnhancementData(enhanceData, totalAdd, 'Add');
    }
    if (method == 'remove') {
      enhanceData[room].enhanceData.enhancements[enhanceOfferIndex].selected = 'N';
      enhanceData[room].room['quoteGrandTotal'] = grandTotal;
      if (enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['resortFee'] == true) {
        enhanceData[room].room['resortFeeTotal'] = rval;
        enhanceData[room].room['resortFeeTotalTax'] = rtax;
      } else {
        enhanceData[room].room['recurringChargesTotal'] = val;
        enhanceData[room].room['recurringChargesTotalTax'] = tax;
      }
      let totalSub =
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTotal']) +
        parseFloat(enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['recurringChargeTaxTotal']);
      for (var i = 0; i < enhanceData[room].SelectedEnhancements.length; i++) {
        if (
          enhanceData[room].SelectedEnhancements[i] &&
          enhanceData[room].SelectedEnhancements[i]['requestCode'] ==
            enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['requestCode']
        ) {
          enhanceData[room].SelectedEnhancements.splice(i, 1);
        }
      }
      if (this._config.PropertyData.permissions.functionalPermissions.allowEnhancementSelectionForSpecificDays) {
        enhanceData[room].enhanceData.enhancements[enhanceOfferIndex]['totalEnhancement'] = [];
      }

      this.updateEnhancementData(enhanceData, totalSub, 'Remove');
    }
  }

  updateRoomWithGuestDetails(roomLists, parent) {
    this.CpinService.updateGuestInfo(roomLists);
    this.data = roomLists;
    this.data$.next(this.data);
    localStorage.setItem(this.tenantId + '-' + this.propertyId + '-' + 'cart', JSON.stringify(this.data));
  }
  updateRoomDetailsAfterBooking(roomLists, parent) {
    if (roomLists.length == 0) {
      this.previousTotal = 0;
      this.total$.next(0);
    } else {
      let quoteGrandTotal = 0;
      for (let j = 0; j < roomLists.length; j++) {
        quoteGrandTotal = quoteGrandTotal + roomLists[j].room.quoteGrandTotal;
      }
      this.previousTotal = quoteGrandTotal;
      this.total$.next(this.previousTotal);
    }
    this.updateRoomWithGuestDetails(roomLists, parent);
  }

  policyBoxes(selectedRoom) {
    let paramData = 'PolicyBox';
    this.getCurrency((paramData) => {
      console.log(this.currencyInfo);
      if (this.currencyInfo == 'USD') {
        this.newRate = 1;
        this.newCurrency = 'fa-usd';
      } else {
        this.newCurrency = this.currencyInfo['fonticon'];
        this.newRate = this.currencyInfo['currencyValue'];
      }
      if (selectedRoom) {
        $('#commonModal').modal('show');
        let modalTitle = this.rGuestBookMessages.footer.depstandCanclatnPolicyHeader;
        let modalBody = selectedRoom.cancelDescription;
        let modalBody1 = selectedRoom.depositDescription;
        let deposit_amount = Math.round(selectedRoom.depositAmountDue * this.newRate * 100) / 100;
        let Cancel_amount = Math.round(selectedRoom.cancelAmountDue * this.newRate * 100) / 100;
        $('#CommonTitle').html(modalTitle);
        $('#Body1Title').html(this.rGuestBookMessages.footer.depositPolicyTitle);
        $('#Body1Message').html(selectedRoom.depositDescription || this.rGuestBookMessages.footer.depositNoDescription);
        if (deposit_amount) {
          $('#Body1AmountLabel').html(this.rGuestBookMessages.footer.depositKeyName1);
          if (this.previousClass) {
            $('#Body1currencyicon').removeClass(this.previousClass);
            this.previousClass = '';
          }
          $('#Body1currencyicon').addClass(this.newCurrency);
          this.previousClass = this.newCurrency;
          let dep_amt = this.datePipe.transform(deposit_amount, '1.2-2');
          $('#Body1Amount').html(dep_amt || 'NULL');
        }

        $('#Body2Title').html(this.rGuestBookMessages.footer.cancellationPolicyTitle);
        $('#Body2Message').html(selectedRoom.cancelDescription || this.rGuestBookMessages.footer.cancellationNoDescription);
        if (selectedRoom.cancelDueDate != 'NA') {
          if (this.previousClass) {
            $('#Body2currencyicon').removeClass(this.previousClass);
            this.previousClass = '';
          }
          $('#Body2currencyicon').addClass(this.newCurrency);
          this.previousClass = this.newCurrency;
          $('#Body2DateLabel').html(this.rGuestBookMessages.footer.cancellationKeyName1);
          $('#Body2Date').html(selectedRoom.cancelDueDate || '-');
          $('#Body2AmountLabel').html(this.rGuestBookMessages.footer.cancellationKeyName2);
          let Cancel_amt = this.datePipe.transform(Cancel_amount, '1.2-2');
          $('#Body2Amount').html(Cancel_amt || '-');
        }
      }
    });
  }

  accordCollapse(index) {
    if ($('#accordion-a-' + index).is('.active')) {
      $('#accordion-a-' + index).removeClass('active');
      $('#accordion-a-' + index)
        .parent()
        .addClass('accordion-section-active-parent');
      $('#accordion-' + index)
        .slideUp(500)
        .removeClass('open');
      $('#accordion-a-' + index + ' i.carupdown').removeClass('caret-active');
      $('#accordion-a-' + index + ' i.carupdown').removeClass('fa-caret-down');
      $('#accordion-a-' + index + ' i.carupdown').addClass('fa-caret-up');
    } else {
      // $(".accordion .accordion-section-title").removeClass("active");
      //$(".accordion .accordion-section-content").slideUp(500).removeClass("open");
      $('#accordion-a-' + index).addClass('active');
      $('#accordion-a-' + index + ' i.carupdown').addClass('fa-caret-down');
      $('#accordion-a-' + index + ' i.carupdown').removeClass('fa-caret-up');
      $('#accordion-a-' + index)
        .parent()
        .removeClass('accordion-section-active-parent');
      $('#accordion-' + index)
        .slideDown(500)
        .addClass('open');
      $('#accordion-a-' + index + ' i.fa-caret-down').addClass('caret-active');
    }
    var moveTopPosition = index > 0 ? 80 : 0;
    $('.bookcomponent').animate({ scrollTop: $('#accordion-a-' + index).position().top + moveTopPosition }, 'slow');
  }
  getCurrency(_callback) {
    console.log('Call back is' + arguments);
    this.currencyservices.currentMessage.subscribe((result) => {
      this.currencyInfo = result;
      _callback();
    });
  }

  refreshData(dta) {
    this.data = dta;
    this.data$.next(this.data);
    this.CpinService.updateGuestInfo(this.data);
  }

  getCountryCode(url): Observable<any> {
    return this.httpService.get(url);
  }

  getFonts() {
    Object.keys(this.fontsnormal).forEach((element) => {
      this.InstallFont(element, this.fontsnormal[element]);
    });
  }

  public async InstallFont(key, urlPart: any) {
    if (environment.multiLanguageSupport === 'true') {
      const fontUrl = `${this._config.configURL}/config/assets/fonts/${urlPart}.ttf`;
      const urlWithToken = this.azureBlobToken.transform(fontUrl);
      this.toDataURL(`${urlWithToken}`, (fata) => {
        this.fontReplace(fata, key);
      });
    } else {
      this.toDataURL(`${this._config.fontsURL}${urlPart}.ttf?`, (fata) => {
        this.fontReplace(fata, key);
      });
    }
  }

  fontReplace(fata, key) {
    let base64 = fata.replace(/^.+?(;base64),/, '');
    if (key == 'normal') {
      this.fontNormal = base64;
    } else {
      this.fontBold = base64;
    }
  }

  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        let imagedata: any = reader.result;
        callback(imagedata);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }
}
